module.exports = __webpack_public_path__ + "static/img/icon_hzh.d4051849.png";